import { GameRunnerType, GameRunnerVersion } from './types';
import { GameRunner as GameRunner0_1_0 } from './v0.1.0/GameRunner';
import { GameRunner as GameRunner0_4_0 } from './v0.4.0/GameRunner';
import { GameRunner as GameRunner0_7_1 } from './v0.7.1/GameRunner';

const VERSIONS: any = [
    ['0.1', GameRunner0_1_0],
    ['0.4', GameRunner0_4_0],
    ['0.7.1', GameRunner0_7_1],
];

export const GameRunnerMap: Map<GameRunnerVersion, GameRunnerType> = new Map(VERSIONS);
GameRunnerMap.set('latest', VERSIONS[VERSIONS.length - 1][1]);

// eslint-disable-next-line react-refresh/only-export-components
export const GameRunnerList = [...GameRunnerMap.keys()];
